/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {Redirect, Route, Switch, useHistory, useLocation} from 'react-router-dom'
import {Error500} from '../Error500'
import {Error404} from '../Error404'
import {NoPermission} from '../NoPermission'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import logo from '../../../../_metronic/assets/img/Waste_Porter_logo_Long_Black.png';

const ErrorsPage: React.FC = () => {
  const history = useHistory()
  const location = useLocation()

  const redirectToDashboard = () => {
    history.push('/')
  }
  const redirectToBack = () => {
    history.go(-3)
  }

  return (
    <div className='d-flex flex-column flex-root'>
      <div
        className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
        style={{backgroundImage: `url('${toAbsoluteUrl('/media/illustrations/progress-hd.png')}')`}}
      >
        <div className='d-flex flex-column flex-column-fluid text-center p-10 py-lg-20'>
          <a href='/dashboard' className='mb-10 pt-lg-20'>
            <img
              alt='Logo'
              src={toAbsoluteUrl(logo)}
              className='h-50px mb-5'
            />
          </a>
          <div className='pt-lg-10 mb-10'>
            <Switch>
              <Route path='/error/404' exact={true}>
                <Error404 />
              </Route>
              <Route path='/error/500' exact={true}>
                <Error500 />
              </Route>
              <Route path='/error/no-permission' exact={true}>
                <NoPermission />
              </Route>
              <Redirect from='/error' exact={true} to='/error/404' />
              <Redirect to='/error/404' />
            </Switch>

            <div className='text-center'>
              {location.pathname === '/error/no-permission' && <a onClick={redirectToBack} className='btn btn-lg btn-primary fw-bolder me-2'>
                Back
              </a>}
              <a onClick={redirectToDashboard} className='btn btn-lg btn-primary fw-bolder'>
                Go to homepage
              </a>
            </div>
          </div>
          <div
            className='
          d-flex
          flex-row-auto
          bgi-no-repeat
          bgi-position-x-center
          bgi-size-contain
          bgi-position-y-bottom
          min-h-100px min-h-lg-350px
        '
            style={{
              backgroundImage: `url('${toAbsoluteUrl('/media/illustrations/sketchy-1/17.png')}')`,
            }}
          ></div>
        </div>

      </div>
    </div>
  )
}

export {ErrorsPage}
